function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9634 22.0167C35.0318 21.6988 35.0058 21.3679 34.8885 21.0647C34.7712 20.7614 34.5678 20.4991 34.3034 20.31L10.97 3.64333C10.7075 3.45453 10.3956 3.34628 10.0725 3.3318C9.74943 3.31732 9.42913 3.39725 9.15073 3.56182C8.87233 3.72638 8.64788 3.96846 8.5048 4.25849C8.36172 4.54852 8.3062 4.87394 8.34502 5.195L11.6784 33.5283C11.7167 33.8532 11.8498 34.1595 12.0611 34.4092C12.2723 34.6589 12.5524 34.841 12.8663 34.9327C13.1803 35.0244 13.5143 35.0216 13.8267 34.9248C14.1392 34.8281 14.4162 34.6415 14.6234 34.3883L20.6434 27.0283L26.2717 36.1283L29.1067 34.375L23.5117 25.3283L33.66 23.2983C33.9789 23.2359 34.2725 23.0811 34.5042 22.8533C34.7359 22.6254 34.8956 22.3345 34.9634 22.0167V22.0167ZM20.5067 22.5333C20.1283 22.6088 19.7878 22.8132 19.5434 23.1117L14.53 29.24L12.095 8.545L29.2334 20.7867L20.5067 22.5333V22.5333Z",
  fill: "#CBD5E0"
});

var SvgInternet = function SvgInternet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInternet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/internet.8478cf6d.svg";
export { ForwardRef as ReactComponent };